import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MeusVeiculosCreatePageRoutingModule } from './meus-veiculos-create-routing.module';

import { MeusVeiculosCreatePage } from './meus-veiculos-create.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    MeusVeiculosCreatePageRoutingModule,
  ],
  declarations: [MeusVeiculosCreatePage]
})
export class MeusVeiculosCreatePageModule {}
